import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { configureTelemetry } from '@ms/yammer-telemetry';
import { getTelemetryClientConfig, updateClientContext } from '@ms/yammer-telemetry-store';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';
import { isDomainRedirect as isLoadedFromDomainRedirect } from '@ms/yammer-web-support/dist/location';

import config from '../../config';
import { persistConfig } from '../../persistedState';

type SetupTelemetry = (options: { readonly isPWA: boolean }) => Promise<void>;
export const setupTelemetry: SetupTelemetry = async ({ isPWA }) => {
  const shouldLogProtobufEventsToConsole = (await getPersistedExperimentTreatment(
    persistConfig.key,
    'LogProtobufEvents'
  )) as boolean;

  const clientContext = getClientContext();
  const isDomainRedirect = isLoadedFromDomainRedirect();

  configureTelemetry({
    config,
    telemetryClientId: config.application.applicationId,
    hostingConfig: readHostingConfiguration(),
    registerUnhandledEventsListener: true,
    clientContext: { ...clientContext, isPWA, isDomainRedirect },
    shouldLogProtobufEventsToConsole,
    enableLongAnimationFrameTimingReporting: true,
    isMsal: true,
  });

  updateClientContext({ hostSessionId: getTelemetryClientConfig()?.appInstanceId });
};
